"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.StyledCollapseView = exports.StyledCollapseIcon = exports.StyledCollapseGroup = exports.StyledCollapseContent = exports.StyledCollapse = void 0;

var _collapse = _interopRequireDefault(require("./collapse"));

var _collapseGroup = _interopRequireDefault(require("./collapse-group"));

var _collapse2 = require("./collapse.styles");

exports.StyledCollapse = _collapse2.StyledCollapse;
exports.StyledCollapseView = _collapse2.StyledCollapseView;
exports.StyledCollapseContent = _collapse2.StyledCollapseContent;
exports.StyledCollapseIcon = _collapse2.StyledCollapseIcon;
exports.StyledCollapseGroup = _collapse2.StyledCollapseGroup;
_collapse.default.Group = _collapseGroup.default; // export styled components

var _default = _collapse.default;
exports.default = _default;